import subscribe from 'callbag-subscribe';
import { useEffect, useState } from 'react';

function useCallbag(factory) {
  var _useState = useState(),
      state = _useState[0],
      setState = _useState[1];

  useEffect(function () {
    return subscribe(setState)(factory());
  }, []);
  return state;
}

export default useCallbag;